module.exports = __webpack_public_path__ + "img/empty-caijiazhen.835b3102.png";